import { FormType } from "enums/form";

export const FORM_TYPE_MAP = {
  [FormType.THREE_HUNDRED_SIXTY]: "360 Feedback",
  [FormType.PEER]: "Peer Feedback",
  [FormType.ANYTIME]: "Anytime Feedback",
  [FormType.PULSE_SURVEY]: "Pulse survey",
};
